import {Navigate, Outlet, useLocation} from "react-router-dom";
import { UserContext } from "../contexts/UserContext";
import { useContext } from "react";

const AuthRoute = () => {

    const location = useLocation();
    const {user} = useContext(UserContext);

    return user.isLogged ? <Outlet /> : <Navigate to={'/login'} state={{redirect: location.pathname}} />
}

export default AuthRoute;